// extracted by mini-css-extract-plugin
module.exports = {"body":"Input_body__hQ1QY","error":"Input_error__sTHeK"};